/* --------------------------------------------------------------------------------------
   errorAlert.component.js
   Copyright © 2019 Xerox Corporation. All Rights Reserved.

   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

export const errorAlertComponent = {
  template: `
  <div id="error-alert" xw-alert display="vm.error" close-button title="{{ 'ERROR' | translate}}" on-close="vm.onClose()">
    <br>
    <!-- <p style="font-size: 14px;">{{vm.error}}</p> -->
    <p translate>TRY_AGAIN</p>
    <br>
  </div>
  `,
  controllerAs: 'vm',
  bindings: {
    error: '<',
    onClose: '&'
  }
}



// WEBPACK FOOTER //
// ./src/app/components/errorAlert.component.js